import { HgSupportedLanguage } from '@smg-real-estate/domus';

import { isPlatformIs24 } from '@/helpers/platformDetection';

const HG_PARTNER_BADGE_URLS: Record<HgSupportedLanguage, string> = {
  [HgSupportedLanguage.DE]: 'https://www.homegate.ch/c/de/ratgeber/funktionen/partnerbadge',
  [HgSupportedLanguage.FR]: 'https://www.homegate.ch/c/fr/guide/services/partnerbadge',
  [HgSupportedLanguage.EN]: 'https://www.homegate.ch/c/en/advisor/features/partnerbadge',
  [HgSupportedLanguage.IT]: 'https://www.homegate.ch/c/it/guida/funzionalita/partnerbadge',
};

const IS24_PARTNER_BADGE_URLS: Record<HgSupportedLanguage, string> = {
  [HgSupportedLanguage.DE]:
    'https://www.immoscout24.ch/c/de/immobilien-magazin/funktionen/partnerbadge',
  [HgSupportedLanguage.FR]:
    'https://www.immoscout24.ch/c/fr/magazine-immobilier/services/partnerbadge',
  [HgSupportedLanguage.EN]: 'https://www.immoscout24.ch/c/en/guide/features/partnerbadge',
  [HgSupportedLanguage.IT]:
    'https://www.immoscout24.ch/c/it/rubrica-immobiliare/funzionalita/partnerbadge',
};

const FALLBACK_LANGUAGE = HgSupportedLanguage.DE;

export function getPartnerBadgeExplanationUrl(language: HgSupportedLanguage): string {
  const urls = isPlatformIs24() ? IS24_PARTNER_BADGE_URLS : HG_PARTNER_BADGE_URLS;

  return urls[language] ?? urls[FALLBACK_LANGUAGE];
}
